
import React from 'react';
import '@nike/ruxac/styles';
import '../Styles/constants.scss';

import Navbar from '../../../Navbar';
import config from '../../../../config/oAuthConfig'
import { loginUser } from '../../index';
import { useDispatch } from 'react-redux';

export const ErrorMessage = ({ children }) => {
  const dispatch = useDispatch();
  return (
    <div>
      <Navbar
        appTitle="PCX Data Loader App"
        loginComponent={<a onClick={() => dispatch({ type: loginUser.type })} href={config.pathName} >Login</a>}

      />

      <div className="error-message-container">

        <h3>You logged out of DLA. You must close Window or log back in.</h3>
      </div>
    </div>
  );
}
export default ErrorMessage;
